import { render } from "./LanguageToggle.vue?vue&type=template&id=b20d4ca8&scoped=true"
import script from "./LanguageToggle.vue?vue&type=script&lang=js"
export * from "./LanguageToggle.vue?vue&type=script&lang=js"

import "./LanguageToggle.vue?vue&type=style&index=0&id=b20d4ca8&scoped=true&lang=css"

import exportComponent from "E:\\桌面\\微播app官网\\wan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b20d4ca8"]])

export default __exports__